<script>
import { computed, onMounted } from 'vue'
import _map from 'lodash/map'

import { resizeUrl } from '../../../../../Greativ/helper/resize'
import LazyLoad from 'vanilla-lazyload'

const lazyLoadInstance = new LazyLoad({
  elements_selector: '.lazy-image-tag',
  callback_enter: (el) => {
    el.classList.add('opacity-0')
    setTimeout(() => {
      el.classList.add('transition-opacity', 'duration-300')
      setTimeout(() => el.classList.remove('opacity-0'), 1)
    }, 50)
  },
})

export default {
  props: {
    class: {
      type: String,
      default: '',
    },
    fallbackImage: {
      type: String,
      required: true,
    },
    fallbackImageWidth: {
      type: Number,
      required: true,
    },
    fallbackImageHeight: {
      type: Number,
      required: true,
    },
    fallbackImageAlt: {
      type: String,
      required: true,
    },
    loadingImage: {
      type: String,
      required: false,
      default: '',
    },
    sizes: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const makeUrl = (url, config) => {
      if (url.includes('://')) {
        return url
      }
      return `${resizeUrl(url, { ...config, fm: 'webp' })} 1x, ${resizeUrl(
        url,
        { ...config, fm: 'webp', dpr: 2 }
      )} 2x`
    }

    const makeType = (url) => {
      const type = url.split('?')[0].split('.').pop().toLowerCase()

      if (url.includes('://')) {
        if (type === 'jpeg' || type === 'jpg') {
          return 'image/jpeg'
        }
        if (type === 'png') {
          return 'image/png'
        }
        if (type === 'svg') {
          return 'image/svg+xml'
        }
      }

      if (type === 'svg') {
        return 'image/svg+xml'
      }

      return 'image/webp'
    }

    const cssClasses = computed(() => {
      return `${props.class} lazy-image-tag`
    })

    const sizes = computed(() => {
      return _map(props.sizes, (size) => {
        return {
          ...size,
          url: makeUrl(size.url, size.config),
          type: makeType(size.url),
        }
      })
    })

    onMounted(() => {
      lazyLoadInstance.update()
    })

    return {
      resizeUrl,
      sizes,
      cssClasses,
    }
  },
}
</script>

<template>
  <picture>
    <source
      v-for="size in sizes"
      :key="size.mediaRule"
      :media="`(min-width:${size.mediaRule}px)`"
      :data-srcset="size.url"
      :type="size.type"
    />
    <img
      :src="loadingImage"
      :alt="fallbackImageAlt"
      :class="cssClasses"
      :data-src="fallbackImage"
    />
  </picture>
</template>

<style lang="scss" scoped>
img:not([src]):not([srcset]) {
  visibility: hidden;
}
</style>
